<template>
  <div class="accred-comps-documents__item">
    <div class="columns is-multiline is-vcentered">
      <div class="column is-4">
        <span class="has-text-grey">{{ label }}</span>
      </div>
      <div class="column is-8">
        <transition name="fade" mode="out-in">
          <div v-if="newItem.file" class="accred-comps-documents__download">
            <file-download :disabledTrue="true" :disabled="!isRead" :disableDelete="isAuditor || !isDelete" :file="newItem.file" @remove="removeDocument"/>
            <b-field class="accred-comps-documents__action-statuses">
              <b-radio-button :disabled="isAuditor"  v-model="newItem.status" :native-value="status.id" :type="status.style" v-for="status of STATUSES_OPTIONS" :key="status.id">
                <span class="is-size-4">{{ status.label }}</span>
              </b-radio-button>
            </b-field>
          </div>
          <div v-else class="accred-comps-documents__upload">
            <file-upload :disabled="isAuditor || !isCreate" category="de-accreditation-doc" :item-guid="accredCompGuid" @uploaded="fileUploaded" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const STATUSES = {
  VERIFYING: 'verifying',
  FORMALLY_AGREED: 'formally_agreed',
  APPROVED: 'approved',
  REJECTED: 'rejected'
}
export default {
  name: 'WsAccredCompsDocumentsItem',
  props: {
    item: {
      type: Object
    },
    label: {
      type: String
    },
    document: {
      type: String
    },
    accredCompGuid: {
      type: String,
      default: ''
    },
    perm: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      STATUSES_OPTIONS: {
        FORMALLY_AGREED: {
          id: STATUSES.FORMALLY_AGREED,
          style: 'is-primary',
          label: this.$t('Формально согласован')
        },
        APPROVED: {
          id: STATUSES.APPROVED,
          style: 'is-success',
          label: this.$t('Окончательно согласован')
        },
        REJECTED: {
          id: STATUSES.REJECTED,
          style: 'is-danger',
          label: this.$t('Отклонить')
        }
      },
      newItem: {
        file: null,
        status: 'verifying',
        document: ''
      }
    }
  },
  computed: {
    ...mapState('authentication', ['currentRole']),
    isAuditor () {
      return this.currentRole === 'front_auditor'
    },
    isDelete () {
      return this.perm.includes('delete')
    },
    isCreate () {
      return this.perm.includes('create')
    },
    isRead () {
      return this.perm.includes('read')
    }
  },
  watch: {
    item: {
      handler (item) {
        if (item) {
          Object.assign(this.newItem, item)
        }
        this.newItem.document = this.document
      },
      deep: true,
      immediate: true
    },
    newItem: {
      handler (item) {
        this.$emit('change', item)
      },
      deep: true
    }
  },
  methods: {
    removeDocument () {
      Object.assign(this.newItem, {
        file: null
      })
    },
    fileUploaded ([file]) {
      this.newItem.file = file
    }
  }
}
</script>

<style lang="scss">
  .accred-comps-documents__action-statuses {
    .b-radio {
      align-items: center;
    }
  }
</style>
